export const SPOTLIGHT_MEDIA_QUERY = 705;
export const CONTENT_PAGE_MARGIN = 6;

export enum SpotlightTrackEvent {
  SpotlightTrigger = 'Spotlight: search opened',
  Spotlight = 'Spotlight: Navigation',
  SpotlightSuggestions = 'Spotlight: Suggestion used',
}
